import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/role_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Role',
    column_type: 'string',
    label_key_path: 'role.name',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      options: ['super', 'application', 'designer', 'merchandiser', 'salesman', 'not_any', 'custom', 'sales_director', 'supplier', 'supplier_boss', 'cheif_pattern_making_officier', 'pattern_maker', 'craftsman', 'quality_inspector', 'plate_reviewer', 'purchaser', 'guest'],
    },
    model_name: 'Role',
    label_key_path: 'role.kind',
  },
  kind_in: {
    column_type: 'enum',
    extra: {
      options: ['super', 'application', 'designer', 'merchandiser', 'salesman', 'not_any', 'custom', 'sales_director', 'supplier', 'supplier_boss', 'cheif_pattern_making_officier', 'pattern_maker', 'craftsman', 'quality_inspector', 'plate_reviewer', 'purchaser', 'guest'],
    },
    model_name: 'Role',
    label_key_path: 'role.kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'custom_permissions': { required: false, disabledUpdate: false },
  },
  'custom_permissions': {
    'user': { required: false, disabledUpdate: false },
    'page': { required: false, disabledUpdate: false },
    'custom_page': { required: false, disabledUpdate: false },
    'application': { required: false, disabledUpdate: false },
  },
  'custom_permissions.user': {
    'read': { required: false, disabledUpdate: false },
    'update': { required: false, disabledUpdate: false },
  },
  'custom_permissions.page': {
    'read': { required: false, disabledUpdate: false },
    'create': { required: false, disabledUpdate: false },
    'update': { required: false, disabledUpdate: false },
    'destroy': { required: false, disabledUpdate: false },
  },
  'custom_permissions.custom_page': {
    'read': { required: false, disabledUpdate: false },
    'create': { required: false, disabledUpdate: false },
    'update': { required: false, disabledUpdate: false },
    'destroy': { required: false, disabledUpdate: false },
    'publish': { required: false, disabledUpdate: false },
  },
  'custom_permissions.application': {
    'read': { required: false, disabledUpdate: false },
    'update': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Role', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Role', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
